module.exports = __webpack_public_path__ + "static/media/NutritionComplete.b8e10386.png";